import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useFormStore } from '../stores/form';
export default {
  __name: 'AbSubscriptionCard',
  props: {
    image: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    action: {
      type: String,
      default: null
    },
    showActionBar: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    price: {
      type: Number,
      default: null
    },
    period: {
      type: String,
      default: null
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var store = useFormStore();
    var membershipOptions = computed(function () {
      var options = [];
      props.options.forEach(function (option) {
        if (option.name !== 'Toegangssleutel' && option.name !== 'Inschrijfgeld') {
          options.push(option);
        }
      });
      return options;
    });
    function transformToPrice(price) {
      var formattedPrice = parseFloat(price).toFixed(2);
      return price < 0.01 ? 'Gratis!' : formattedPrice.replace('.', ',');
    }
    return {
      __sfc: true,
      store: store,
      props: props,
      membershipOptions: membershipOptions,
      transformToPrice: transformToPrice
    };
  }
};